import { defineMessages } from 'react-intl'

export const dashboardMessages = defineMessages({
  findRoutes: {
    id: 'dashboard.findRoutes',
    defaultMessage: 'Find Routes'
  },
  planARoute: {
    id: 'dashboard.planARoute',
    defaultMessage: 'Plan a Route'
  },
  recordAndNavigate: {
    id: 'dashboard.recordAndNavigate',
    defaultMessage: 'Record & Navigate'
  }
})
